export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7960.821682b4.jpg";